(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lj-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function installReviewJump() {
      const template = document.getElementById('LJReviewJumpTemplate');
      const scope = document.querySelector('.shopify-section-product-section');
      if (!template || !scope || scope.querySelector('.lj-review-jump')) return;
      const prices = Array.from(scope.querySelectorAll('product-price'));
      const price = prices.find(node => !node.closest('sticky-add-to-cart, .sticky-add-to-cart') && node.getClientRects().length > 0);
      const submit = scope.querySelector('form[action*="/cart/add"] button[type="submit"]');
      const purchaseBlock = submit && (submit.closest('sticky-add-to-cart, .sticky-add-to-cart') || submit.parentElement);
      const link = template.content.firstElementChild.cloneNode(true);
      if (price) price.insertAdjacentElement('afterend', link);
      else if (purchaseBlock) purchaseBlock.insertAdjacentElement('beforebegin', link);
    }
    function startReviewJump() {
      installReviewJump();
      const scope = document.querySelector('.shopify-section-product-section');
      if (scope) new MutationObserver(installReviewJump).observe(scope, {childList:true,subtree:true});
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startReviewJump, {once:true});
    else startReviewJump();
    document.addEventListener('shopify:section:load', installReviewJump);
    document.addEventListener('click', event => {
      const link = event.target.closest('.lj-review-jump');
      const reviews = document.getElementById('avis-clients');
      if (!link || !reviews) return;
      event.preventDefault();
      const details = reviews.querySelector('details');
      if (details) details.open = true;
      const focusTarget = details ? details.querySelector('summary') : reviews.querySelector('[tabindex]');
      if (focusTarget) focusTarget.focus({preventScroll:true});
      history.replaceState(null, '', '#avis-clients');
      reviews.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
